import * as React from 'react';

import { observer } from 'mobx-react';

import { Body2 } from '@estee/elc-typography';

import { textFieldClasses } from '~utils/Classes';

export interface ITextLinkProps {
    inputLabel: string;
    name: string;
    url: string;
    openInBlank?: boolean;
    isActive?: boolean;
    onClick?(name: string): void;
}

export const TextLink = observer(
    ({ inputLabel, name, url, openInBlank, isActive, onClick }: ITextLinkProps) => {
        return (
            <a
                href={url}
                className={isActive ? 'is_language_selected' : ''}
                target={openInBlank ? '_blank' : '_self'}
                onClick={() => onClick?.(name)}
            >
                <Body2 className={textFieldClasses(name)}>{inputLabel}</Body2>
            </a>
        );
    }
);
